import Vue from 'vue'
import _ from 'lodash'
import {
  fetchWeaponVideos,
  fetchWeaponTips,
  fetchWeaponRecoilVisuals,
  fetchWeaponById,
  fetchMapWeaponTierList,
  fetchMapWeaponBuyGuides
} from '@/api/csgo'

const state = () => ({
  items: [],
  maps: [],
  sortMethod: 'tier',
  selectedMap: null,
  tierListSelectedTeam: 'BOTH'
})

const mutations = {
  'SET_ITEMS': (state, payload) => {
    Vue.set(state, 'items', payload)
  },
  'UPDATE_OR_ADD_ITEM': (state, payload) => {
    let item = state.items.find((obj) => {
      return obj.id === payload.id
    })
    if (item) {
      let index = state.items.indexOf(item)
      state.items[index] = payload
    } else {
      state.items.push(payload)
      Vue.set(state, 'items', state.items)
    }
  },
  'SET_SORT_METHOD': (state, payload) => {
    Vue.set(state, 'sortMethod', payload)
  },
  'SET_SELECTED_MAP': (state, payload) => {
    Vue.set(state, 'selectedMap', payload)
  },
  'SET_WEAPON_VIDEOS': (state, payload) => {
    let item = state.items.find((obj) => {
      return obj.id === payload.id
    })

    let index = state.items.indexOf(item)
    Vue.set(state.items[index], 'videos', payload.videos)
  },
  'SET_WEAPON_TIPS': (state, payload) => {
    let item = state.items.find((obj) => {
      return obj.id === payload.id
    })

    let index = state.items.indexOf(item)
    Vue.set(state.items[index], 'tips', payload.tips)
  },
  'SET_WEAPON_RECOIL_VISUALS': (state, payload) => {
    let item = state.items.find((obj) => {
      return obj.id === payload.id
    })

    let index = state.items.indexOf(item)
    Vue.set(state.items[index], 'recoilVisuals', payload.recoilVisuals)
  },
  'SET_MAP_WEAPON_TIER_LIST': (state, payload) => {
    if (state.maps[payload.id]) {
      Vue.set(state.maps[payload.id], 'tier_list', payload.tier_list)
    } else {
      Vue.set(state.maps, payload.id, { tier_list: payload.tier_list, buy_guides: [] })
    }
  },
  'SET_MAP_WEAPON_BUY_GUIDES': (state, payload) => {
    if (state.maps[payload.id]) {
      Vue.set(state.maps[payload.id], 'buy_guides', payload.buy_guides)
    } else {
      Vue.set(state.maps, payload.id, { tier_list: [], buy_guides: payload.buy_guides })
    }
  },
  'SET_TIERLIST_SELECTED_TEAM': (state, payload) => {
    state.tierListSelectedTeam = payload
  }
}

const actions = {
  setItems ({commit}, payload) {
    commit('SET_ITEMS', payload)
  },
  fetchMapWeaponData ({commit}, mapId) {
    let tierListPromise = new Promise((resolve, reject) => {
      fetchMapWeaponTierList(mapId).then((data) => {
        commit('SET_MAP_WEAPON_TIER_LIST', {id: mapId, tier_list: data})
        resolve(data)
      }).catch((error) => {
        commit('SET_MAP_WEAPON_TIER_LIST', {id: mapId, tier_list: []})
        resolve(error)
      })
    })

    let buyGuidePromise = new Promise((resolve, reject) => {
      fetchMapWeaponBuyGuides(mapId).then((data) => {
        commit('SET_MAP_WEAPON_BUY_GUIDES', {id: mapId, buy_guides: data})
        resolve(data)
      }).catch((error) => {
        commit('SET_MAP_WEAPON_BUY_GUIDES', {id: mapId, buy_guides: []})
        resolve(error)
      })
    })

    return Promise.all([tierListPromise, buyGuidePromise])
  },
  fetchWeaponData ({commit, getters}, key) {
    let getWeaponOrFetch = new Promise((resolve, reject) => {
      if (!getters.getItemByProp({prop: 'id', value: key})) {
        fetchWeaponById(key).then((data) => {
          commit('UPDATE_OR_ADD_ITEM', data)
          resolve(data)
        }).catch((error) => {
          window.location = '/404'
          reject(error)
        })
      } else {
        resolve(getters.getItemByProp({prop: 'id', value: key}))
      }
    })

    getWeaponOrFetch.then((response) => {
      let weapon = getters.getItemByProp({prop: 'id', value: key})
      if (weapon) {
        fetchWeaponVideos(weapon.id).then((data) => {
          commit('SET_WEAPON_VIDEOS', {id: weapon.id, videos: data})
        }).catch((error) => {
          commit('SET_WEAPON_VIDEOS', {id: weapon.id, videos: null})
          console.log(error)
        })
        fetchWeaponTips(weapon.id).then((data) => {
          commit('SET_WEAPON_TIPS', {id: weapon.id, tips: data})
        }).catch((error) => {
          commit('SET_WEAPON_TIPS', {id: weapon.id, tips: null})
          console.log(error)
        })
        if (weapon.recoilVisuals) {
        } else if (weapon.recoilVisuals === null) {
        } else {
          fetchWeaponRecoilVisuals(weapon.id).then((data) => {
            commit('SET_WEAPON_RECOIL_VISUALS', {id: weapon.id, recoilVisuals: data})
          }).catch((error) => {
            commit('SET_WEAPON_RECOIL_VISUALS', {id: weapon.id, recoilVisuals: null})
            console.log(error)
          })
        }
      }
    })
  },
  updateOrAddItem ({commit}, payload) {
    commit('UPDATE_OR_ADD_ITEM', payload)
  },
  setWeaponVideos ({commit}, payload) {
    commit('SET_WEAPON_VIDEOS', payload)
  },
  setWeaponTips ({commit}, payload) {
    commit('SET_WEAPON_TIPS', payload)
  },
  setWeaponRecoilVisuals ({commit}, payload) {
    commit('SET_WEAPON_RECOIL_VISUALS', payload)
  },
  setSortMethod ({commit}, payload) {
    commit('SET_SORT_METHOD', payload)
  },
  setSelectedMap ({commit}, payload) {
    commit('SET_SELECTED_MAP', payload)
  },
  setTierListSelectedTeam ({commit}, payload) {
    commit('SET_TIERLIST_SELECTED_TEAM', payload)
  }
}

const getters = {
  getBuyGuides: (state, getters) => {
    let mapId = getters.getSelectedMap ? getters.getSelectedMap.id : 0
    return state.maps[mapId] ? state.maps[mapId].buy_guides : []
  },
  getTierListSelectedTeam: state => { return state.tierListSelectedTeam },
  getMapsWeaponsData: state => { return state.maps },
  getItem: state => name => {
    return state.items.find((obj) => {
      return (obj.name === name)
    })
  },
  getItemByProp: state => payload => {
    return state.items.find((obj) => {
      return (obj[payload.prop].toString() === payload.value.toString())
    })
  },
  getWeapons: state => {
    return state.items.filter((obj) => {
      return !['gear', 'grenade'].includes(obj.type)
    })
  },
  getMapWeaponTierlist: (state, getters) => mapId => {
    let keyList = _.get(state, 'maps.' + mapId + '.tier_list.' + state.tierListSelectedTeam) || []
    return keyList.map((keyWeapon) => {
      let weaponObject = getters.getWeapons.find((realWeapon) => {
        return realWeapon.id === keyWeapon.weapon_id
      })
      return {
        tier: keyWeapon.tier,
        ...weaponObject
      }
    })
  },
  getItems: state => {
    return state.items
  },
  getGrenades: state => {
    return state.items.filter((obj) => {
      return obj.type === 'grenade'
    })
  },
  getGear: state => {
    return state.items.filter((obj) => {
      return obj.type === 'gear'
    })
  },
  getSortMethod: state => { return state.sortMethod },
  getSortedWeapons: (state, getters) => {
    let mapId = getters.getSelectedMap ? getters.getSelectedMap.id : 0
    if (state.sortMethod === null) {
      return getters.getMapWeaponTierlist(mapId)
    } else if (state.sortMethod === 'tier') {
      return tierSort(getters.getMapWeaponTierlist(mapId), false)
    } else if (state.sortMethod === 'tier-reverse') {
      return tierSort(getters.getMapWeaponTierlist(mapId), true)
    } else if (state.sortMethod === 'damage') {
      return damageSort(getters.getMapWeaponTierlist(mapId), false)
    } else if (state.sortMethod === 'damage-reverse') {
      return damageSort(getters.getMapWeaponTierlist(mapId), true)
    } else if (state.sortMethod === 'armor-damage') {
      return armorDamageSort(getters.getMapWeaponTierlist(mapId), false)
    } else if (state.sortMethod === 'armor-damage-reverse') {
      return armorDamageSort(getters.getMapWeaponTierlist(mapId), true)
    } else if (state.sortMethod === 'cost') {
      return costSort(getters.getMapWeaponTierlist(mapId), false)
    } else if (state.sortMethod === 'cost-reverse') {
      return costSort(getters.getMapWeaponTierlist(mapId), true)
    } else if (state.sortMethod === 'kill-reward') {
      return killRewardSort(getters.getMapWeaponTierlist(mapId), false)
    } else if (state.sortMethod === 'kill-reward-reverse') {
      return killRewardSort(getters.getMapWeaponTierlist(mapId), true)
    }
  },
  getSelectedMap: state => { return state.selectedMap }
}

export default {
  state,
  mutations,
  actions,
  getters
}

const tierSort = (ar, reverse) => {
  return ar.sort((a, b) => {
    let result = 0
    let newA = a.tier.toLowerCase()
    let newB = b.tier.toLowerCase()
    if (newA === 's') {
      result = -1
    } else if (newB === 's') {
      result = 1
    } else if (newA > newB) {
      result = 1
    } else if (newB > newA) {
      result = -1
    }

    if (reverse) {
      return result * -1
    } else {
      return result
    }
  })
}

const damageSort = (ar, reverse) => {
  return ar.sort((a, b) => {
    let result = 0
    if (a.damage < b.damage) {
      result = 1
    } else {
      result = -1
    }

    if (reverse) {
      return result * -1
    } else {
      return result
    }
  })
}

const armorDamageSort = (ar, reverse) => {
  return ar.sort((a, b) => {
    let result = 0
    let armorDamageA = Math.round(a.damage * (a.armor_penetration / 100))
    let armorDamageB = Math.round(b.damage * (b.armor_penetration / 100))
    if (armorDamageA < armorDamageB) {
      result = 1
    } else {
      result = -1
    }

    if (reverse) {
      return result * -1
    } else {
      return result
    }
  })
}

const costSort = (ar, reverse) => {
  return ar.sort((a, b) => {
    let result = 0
    if (a.cost < b.cost) {
      result = 1
    } else {
      result = -1
    }

    if (reverse) {
      return result * -1
    } else {
      return result
    }
  })
}

const killRewardSort = (ar, reverse) => {
  return ar.sort((a, b) => {
    let result = 0
    if (a.kill_reward < b.kill_reward) {
      result = 1
    } else {
      result = -1
    }

    if (reverse) {
      return result * -1
    } else {
      return result
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/weapons.js